let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iB3nT")).then(() => parcelRequire('3toEu'));